export default __webpack_public_path__ + "static/media/tablecaptain.da0f2c8a.png";